(ns teamoesterreich.admin-mode.ui-helper.editable-markdown-card
  (:require-macros [toe-prepare.cljstemplates :refer [deftmpl]])
  (:require
    [teamoesterreich.util.markdown :refer [md]]
    [reagent.core :as r]
    [reagent.dom :as rdom]
    [reagent-material-ui.components :as mui]
    [teamoesterreich.util.log :as log]
    [teamoesterreich.ajax :as ajax]
    [teamoesterreich.admin-mode.data.text-block :as d-text-block]
    [teamoesterreich.view-state :as v-state]
    [teamoesterreich.util.helper :as h]                     ;;(h/event-value e)


    [reagent-material-ui.icons.info :refer [info]]
    [reagent-material-ui.icons.save :refer [save]]
    [reagent-material-ui.icons.edit :refer [edit]]
    [reagent-material-ui.icons.close :refer [close]]
    [reagent-material-ui.icons.done :refer [done]]
    [reagent-material-ui.icons.arrow-drop-down :refer [arrow-drop-down]]
    [reagent-material-ui.icons.keyboard-arrow-left :refer [keyboard-arrow-left]]
    ))


(deftmpl markdown-quick-help "cljs_templates/markdown_quick_help.html")


(defn get-templates [template-group]
  (when (not (and (get-in @v-state/app-state [:text-blocks (keyword template-group)]) (coll? (get-in @v-state/app-state [:text-blocks (keyword template-group)]))))
    (d-text-block/get-group-text-blocks template-group
                                        (fn [res] (swap! v-state/app-state assoc-in [:text-blocks (keyword template-group)] res)))))


(defn >upload-image [url {:keys [file-name buffer content-type width max-height max-width on-finished] :as props}]
  (log/out "UPLOAD" url "--" file-name "--" content-type "--")
  (let [url (str url "?width=" width "&max-height=" max-height "&max-width=" max-width)]
    (ajax/post-file> url buffer file-name content-type on-finished)))


(declare code-mirror-inst)

(defn help-popup [!show]
  [mui/dialog
   {:justifyContent "center"
    :fullWidth      true
    :maxWidth       "md"
    :open           (or @!show false)
    :onClose        #(reset! !show false)}
   [mui/dialog-title
    {:onClose #(reset! !show false)}
    [mui/typography {:variant "h6"} "Markdown Editor Hilfe"]
    [mui/icon-button {:onClick #(reset! !show false) :style {:position "absolute" :right "10px" :top "10px" :color "grey"}} [close]]
    ]
   [mui/dialog-content
    [:div {:dangerouslySetInnerHTML {:__html markdown-quick-help}}]
    ]]
  )


(defn preview [!content]
  (log/out "rerender preview" @!content)
  [:div {:dangerouslySetInnerHTML {:__html (.render md (or @!content ""))}
         :className               "editor-preview-widget"
         :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :minHeight "400px" :padding "10px" :border "1px dotted grey"}}]
  )

(defn editor [!editor-content upload-url]

  (let [upload-file-fn (fn [editor file]
                         (let [cur (.. editor getDoc getCursor)
                               fr (js/FileReader.)]
                           (set! (.-onload fr)
                                 (fn [event]
                                   ;(log/out "read file" event (.. event -target -result))
                                   (>upload-image upload-url {:buffer       (.. event -target -result)
                                                              :file-name    (.-name file)
                                                              :content-type (.-type file)
                                                              :max-width    420
                                                              :on-finished  (fn [url]
                                                                              (log/out "got back URL" url)
                                                                              (.. editor getDoc
                                                                                  (replaceRange
                                                                                    (str " ![" (.-name file) "](" url ")")
                                                                                    cur)))})))
                           (.readAsArrayBuffer fr file)))
        ]
    (fn []
      (r/create-class
        {:reagent-render       (fn []
                                 (log/out "+++++++++++++++++++++ :reagent-render")
                                 [:div.md-editor {:style {:minHeight "300px" :width "45%" :margin-left "15px" :display "inline-block"}}])
         :component-did-mount  (fn [comp]
                                 (let [container (rdom/dom-node comp)
                                       ed (doto
                                            (js/CodeMirror
                                              container
                                              #js {:value        (str @!editor-content)
                                                   :mode         "gfm"
                                                   :theme        "base16-light"
                                                   :lineWrapping true
                                                   :lineNumbers  false
                                                   :extraKeys    #js {"Enter" "newlineAndIndentContinueMarkdownList"}})
                                            (.on "change" (fn [e]
                                                            (log/out "changed" (.getValue e))
                                                            (reset! !editor-content (.getValue e))))
                                            (.on "paste" (fn [editor e]
                                                           (js/console.log "pasted!!!" editor (.-items (.-clipboardData e)))
                                                           (doseq [item_ (array-seq (.-items (.-clipboardData e)))]
                                                             (do
                                                               (js/console.log "pasted Item!!!", (.-kind item_))
                                                               (case (.-kind item_)
                                                                 "file" (do
                                                                          (.preventDefault e)
                                                                          (.stopPropagation e)
                                                                          (upload-file-fn editor (.getAsFile item_))
                                                                          )
                                                                 ;"string" (.. editor getDoc
                                                                 ;             (replaceRange
                                                                 ;               (str " ![" (.-name file) "](" url ")")
                                                                 ;               cur))
                                                                 (js/console.log "Unknown Type:", (.-kind item_))
                                                                 )))
                                                           ))


                                            (.on "drop" (fn [editor event]
                                                          ;(log/out "dropped!!! " upload-url event)
                                                          (when-let [files (array-seq (.. event -dataTransfer -files))]
                                                            ;(log/out "got file" files)
                                                            (.preventDefault event)
                                                            (.stopPropagation event)
                                                            (upload-file-fn editor (first files))
                                                            ))))]
                                   (log/out "editor did mount" comp container)
                                   )

                                 )
         :component-did-update (fn [comp]
                                 (log/out "editor did update" @!editor-content))
         :display-name         "md-edit-component"})
      )
    ))


(defn get-it-inner [!value upload-url & [invalidate]]
  [mui/card
   [mui/card-content
    {:style {:minHeight "150px" :width "100%" :textAlign "left"}}
    (log/log-pr "content changed " invalidate)
    [(editor !value upload-url)]
    [preview !value]
    ]
   ]
  )

(defn get-it [content on-save-fn upload-url & [{:keys [title subText left-button additional-button on-cancel-fn template-group disabled lock-fn]}]]
  (let [lock-fn (or lock-fn (fn [] nil))
        !st (r/atom {:invalidated true :editor-content content :edit-mode false :show-help false :invalidate 0})

        !invalidate (r/cursor !st [:invalidate])
        !editor-mode (r/cursor !st [:edit-mode])
        !editor-content (r/cursor !st [:editor-content])
        !show-help (r/cursor !st [:show-help])

        template-group (or template-group "")
        !template (r/cursor !st [:template])
        !template-set (r/cursor !st [:template-set])
        !templates (r/cursor v-state/app-state [:text-blocks (keyword template-group)])
        _ (get-templates template-group)
        ]
    (fn []
      (let [templates (filter
                        (fn [[c v]]
                          (and
                            ;;TODO orgId
                            (not (false? (:toeTextBlock-active v)))
                            (or (nil? (:toeTextBlock-key v)) (= (:toeTextBlock-key v) ""))
                            (= (:toeTextBlock-type v) "md")))
                        @!templates)

            template_map (reduce (fn [c [k t]] (assoc c k t)) {} templates)
            show-tmpl? (and @!editor-mode (not= template-group "") (not (empty? template_map)))
            ]

        [mui/card
         (when title
           [mui/card-header {:title (str title)}]
           )
         [mui/card-content
          {:style {:minHeight "400px" :width "100%" :textAlign "left"}}
          [help-popup !show-help]
          (if @!editor-mode
            [mui/grid {:container  true
                       :direction  "row"
                       :error      (< (count (str (:userDocument-type @!st))) 1)
                       :justify    "space-between"
                       :spacing    2
                       :style      {:paddingRight "5px"}
                       :alignItems "flex-start"}
             (when show-tmpl?
               [mui/grid {:container false :item true :xs 1 :lg 4} " "])

             (when show-tmpl?
               [mui/grid {:container false :item true :xs 6}
                [mui/input-label {:style {:font-size "12px"}} "Vorlage "]
                [mui/select
                 {:fullWidth true
                  :value     (or @!template "")
                  :onChange  (fn [e]
                               (let [v (h/event-value e)]
                                 (swap! !st assoc
                                        :template v
                                        :template-set (if (= "" v) false true))))
                  }
                 (for [[k v] templates]
                   ^{:key (str "template-" k)}
                   [mui/menu-item {:style {} :value k} (str (:toeTextBlock-name v))])
                 ]
                ])
             (when show-tmpl?
               [mui/grid {:container false :item true :xs 4 :lg 2}
                [mui/button
                 {:style     {:float "right"}
                  :color     "secondary"
                  :variant   "contained"
                  :title     "Vorlage verwenden"
                  :disabled  (not @!template-set)
                  :startIcon (r/as-element [done])
                  :onClick   (fn []
                               (let [tmpl (get template_map (get @!st :template))]
                                 (log/debug "use template " (clj->js (:toeTextBlock-content tmpl)))
                                 (lock-fn false)
                                 (swap! !st assoc
                                        :editor-content (:toeTextBlock-content tmpl)
                                        :invalidate (rand-int 5)
                                        :template-set false)

                                 ))
                  }
                 "verwenden"]])
             [mui/grid {:container false :item true :xs 12}
              [get-it-inner !editor-content upload-url @!invalidate]]
             ]
            [preview !editor-content])

          ]
         [mui/card-content
          (when subText
            [:span subText])]
         [mui/card-actions
          {:style {:marginTop "15px"}}
          (if @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [keyboard-arrow-left])
                         :onClick   (fn []
                                      (when on-cancel-fn (on-cancel-fn))
                                      (lock-fn false)
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Abbrechen"]
            (when-not disabled
              [mui/button {:variant   "contained"
                           :startIcon (r/as-element [edit])
                           :onClick   (fn []
                                        ;(lock-fn true)  ;; TODO needs two clicks ?
                                        (reset! !editor-mode true))
                           }
               "Bearbeiten"]))

          (when @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [save])
                         :color     "primary"
                         :onClick   (fn []
                                      (on-save-fn @!editor-content)
                                      (lock-fn false)
                                      (swap! !st assoc :editor-content content :edit-mode false))
                         }
             "Speichern"])

          (when @!editor-mode
            [mui/button {:variant   "contained"
                         :startIcon (r/as-element [info])
                         :onClick   #(reset! !show-help true)
                         }
             "Info"])

          (when (and (not @!editor-mode) additional-button)
            additional-button)

          ]

         ]

        ))))

(defn preview-small [!content]
  (log/out "rerender preview" @!content)
  [:div {:dangerouslySetInnerHTML {:__html (.render md (or @!content ""))}
         :className               "editor-preview-widget"
         :style                   {:width "45%" :margin-left "5%" :display "inline-block" :vertical-align "top" :minHeight "200px" :padding "10px" :border "1px dotted grey"}}]
  )

(defn editor_small [!editor-content]
  (fn []
    (r/create-class
      {:reagent-render       (fn [] [:div.md-editor {:style {:minHeight "200px" :width "45%" :margin-left "15px" :display "inline-block"}}])
       :component-did-mount  (fn [comp]
                               (let [container (rdom/dom-node comp)
                                     ed (doto
                                          (js/CodeMirror
                                            container
                                            #js {:value        (str @!editor-content)
                                                 :mode         "gfm"
                                                 :theme        "base16-light"
                                                 :lineWrapping true
                                                 :lineNumbers  false
                                                 :extraKeys    #js {"Enter" "newlineAndIndentContinueMarkdownList"}})
                                          (.on "change" (fn [e]
                                                          (log/out "changed" (.getValue e))
                                                          (reset! !editor-content (.getValue e))))
                                          )]
                                 (log/out "editor did mount" comp container)
                                 ))
       :component-did-update (fn [comp]
                               (log/out "editor did update" @!editor-content)
                               ;(let [content' (.getValue comp)]
                               ;  (when (and @!editor-content (not= content' @!editor-content))
                               ;    (.setValue comp @!editor-content)))
                               comp)
       :display-name         "md-edit-small-component"})))


(defn get-it-small [!value & [invalidate]]
  [mui/card
   [mui/card-content
    {:style {:minHeight "150px" :width "100%" :textAlign "left"}}
    (log/log-pr "content changed " invalidate)
    [(editor_small !value)]
    [preview-small !value]
    ]
   ]
  )




